export const routes = {
  // Auth
  login: '/login',
  register: '/register',
  supplierPortal: '/portal/supplier/:token',
  
  // Main
  dashboard: '/dashboard',
  chat: '/chat',
  calendar: '/calendar',
  meetings: '/meetings',
  email: '/email',
  emailCallback: '/email/callback',
  
  // Contacts
  contacts: '/contacts',
  contactsNew: '/contacts/new',
  contactMap: '/contacts/map',
  contactDetail: '/contacts/:id',
  
  // Invoices
  invoices: '/invoices',
  invoicesNew: '/invoices/new',
  invoiceDetail: '/invoices/:id',
  
  // Bills
  bills: '/bills',
  recurringTransactions: '/purchases/recurring',
  billsNew: '/bills/new',
  billDetail: '/bills/:id',
  
  // Purchase Orders
  purchaseOrders: '/purchase-orders',
  purchaseOrdersNew: '/purchase-orders/new',
  purchaseOrderDetail: '/purchase-orders/:id',
  
  // Payments
  payments: '/payments',
  paymentsNew: '/payments/new',
  paymentDetail: '/payments/:id',
  
  // Banking
  bankAccounts: '/bank-accounts',
  bankAccountDetail: '/bank-accounts/:id',
  bankTransactions: '/bank-accounts/:id/transactions',
  
  // Phase 3 - Bank Feeds & Rules
  bankFeeds: '/banking/bank-feeds',
  reconciliation: '/banking/reconciliation',
  connectBank: '/banking/connect-bank',
  bankFeedsCallback: '/banking/bank-feeds/callback',
  bankRules: '/banking/bank-rules',
  bankRulesNew: '/banking/bank-rules/new',
  bankRuleDetail: '/banking/bank-rules/:id',
  
  // Reports
  reports: '/reports',
  profitLoss: '/reports/profit-loss',
  balanceSheet: '/reports/balance-sheet',
  cashFlow: '/reports/cash-flow',
  agedReceivables: '/reports/aged-receivables',
  agedPayables: '/reports/aged-payables',
  gstReport: '/reports/gst',
  basReport: '/reports/bas',
  chartOfAccounts: '/reports/chart-of-accounts',
  trialBalance: '/reports/trial-balance',
  journals: '/reports/journals',
  budgets: '/reports/budgets',
  accountTransactions: '/reports/account-transactions',
  gstDetail: '/reports/gst-detail',
  salesSummary: '/reports/sales-summary',
  purchasesSummary: '/reports/purchases-summary',
  inventoryValuation: '/reports/inventory-valuation',
  
  // Settings
  settings: '/settings',
  automationSettings: '/settings/automation',
  importExport: '/settings/import-export',
  
  // Phase 3 - Documents & OCR
  documents: '/documents',
  documentsUpload: '/documents/upload',
  
  // Phase 3 - Recurring Invoices
  recurringInvoices: '/recurring-invoices',
  recurringInvoicesNew: '/recurring-invoices/new',
  recurringInvoiceDetail: '/recurring-invoices/:id',

  // Credit Notes
  creditNotes: '/credit-notes',
  
  // Phase 3 - Integrations
  integrations: '/integrations',
  connectShopline: '/integrations/connect/shopline',
  integrationSyncStatus: '/integrations/sync-status/:id',
  
  // Phase 4 - Payroll
  employees: '/payroll/employees',
  employeesNew: '/payroll/employees/new',
  employeeDetail: '/payroll/employees/:id',
  payRuns: '/payroll/pay-runs',
  payRunsNew: '/payroll/pay-runs/new',
  payRunDetail: '/payroll/pay-runs/:id',
  payRunItem: '/payroll/pay-runs/:id/items/:itemId',
  payslipViewer: '/payroll/payslips/:id',
  stpSubmissions: '/payroll/stp',
  stpSubmissionDetail: '/payroll/stp/:id',
  superFunds: '/payroll/super/funds',
  superContributions: '/payroll/super/contributions',
  leave: '/payroll/leave',
  leaveApply: '/payroll/leave/apply',
  leaveApprovals: '/payroll/leave/approvals',
  timesheets: '/payroll/timesheets',
  timesheetCalendar: '/payroll/timesheets/calendar',
  abaFiles: '/payroll/aba',
  expenseClaims: '/payroll/expense-claims',
  payrollReports: '/payroll/reports',

  // CRM / Sales
  leads: '/sales/leads',
  quotes: '/quotes',
  quotesNew: '/quotes/new',
  quoteDetail: '/quotes/:id',
  quoteEdit: '/quotes/:id/edit',
  salesOrders: '/sales-orders',
  salesOrdersNew: '/sales-orders/new',
  salesOrderDetail: '/sales-orders/:id',
  salesOrderEdit: '/sales-orders/:id/edit',
  customerPriceLists: '/sales/price-lists',

  // Stock / Inventory
  products: '/stock/products',
  productsNew: '/stock/products/new',
  productDetail: '/stock/products/:id',
  productEdit: '/stock/products/:id/edit',
  stockLevels: '/stock/levels',
  warehouses: '/stock/warehouses',
  stockMovements: '/stock/movements',
  priceHistory: '/stock/price-history',

  // Production
  bom: '/production/bom',
  production: '/production/batches',

  // Shipping
  shipments: '/shipping/shipments',
  containerTracking: '/shipping/containers',

  // FX
  fxDashboard: '/fx',
  fxBeneficiaries: '/fx/beneficiaries',
  fxTransfers: '/fx/transfers',

  // Assets
  assets: '/assets',
  assetUsage: '/assets/usage',
  assetMaintenance: '/assets/maintenance',

  // Projects
  projects: '/projects',
  projectDetail: '/projects/:id',
  timeTracking: '/projects/time',

  // Files
  files: '/files',

  // Settings (new)
  documentTemplates: '/settings/templates',
  activityLog: '/settings/activity-log',
  companyBranding: '/settings/branding',
} as const;

export type Routes = typeof routes;

// Helper function to generate route with params
export function generateRoute(
  route: string,
  params: Record<string, string>
): string {
  let result = route;
  Object.entries(params).forEach(([key, value]) => {
    result = result.replace(`:${key}`, value);
  });
  return result;
}
